import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Chip, Stack } from "@mui/material";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import AdicionalesManager from "./AdicionalesManager";
import ProcesosApi from "api/procesosApi";

const AdicionalesForm = ({ procesoId }) => {
  const [showNewAdicionalModal, setShowNewAdicionalModal] = useState(false);
  const [procesoData, setProcesoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProcesoData = async () => {
      try {
        const response = await ProcesosApi.fetchProcesoById(procesoId);
        setProcesoData(response.data);
      } catch (error) {
        console.error("Error al obtener datos del proceso:", error);
      } finally {
        setLoading(false);
      }
    };

    if (procesoId) {
      fetchProcesoData();
    }
  }, [procesoId]);

  const renderAdicionalesToAdd = () => {
    if (!procesoData) return null;

    const adicionales = [];
    if (procesoData.personas_a_cargo) {
      adicionales.push("Personas a Cargo");
    }
    if (procesoData.sociedades) {
      adicionales.push("Sociedades");
    }
    if (procesoData.procesos_judiciales) {
      adicionales.push("Procesos Judiciales");
    }

    if (adicionales.length === 0) return null;

    return (
      <SuiBox mb={1}>
        <SuiTypography variant="h5" fontWeight="dark">
          Debe agregar:
        </SuiTypography>
        <Stack direction="row" spacing={1} mt={1}>
          {adicionales.map((adicional) => (
            <Chip
              key={adicional}
              label={adicional}
              color="info"
              variant="outlined"
              size="small"
              sx={{
                borderRadius: "16px",
                backgroundColor: "transparent",
                px: 2, // padding horizontal
                py: 1, // padding vertical
                "& .MuiChip-label": {
                  color: "info.main",
                  fontWeight: "regular",
                  fontSize: "0.9rem",
                  padding: "0 6px",
                },
              }}
            />
          ))}
        </Stack>
      </SuiBox>
    );
  };

  if (loading) {
    return <SuiBox p={2}>Cargando...</SuiBox>;
  }

  return (
    <Box>
      {renderAdicionalesToAdd()}
      <AdicionalesManager
        procesoId={procesoId}
        showNewAdicionalModal={showNewAdicionalModal}
        setShowNewAdicionalModal={setShowNewAdicionalModal}
        procesoData={procesoData}
      />
    </Box>
  );
};

AdicionalesForm.propTypes = {
  procesoId: PropTypes.number.isRequired,
};

export default AdicionalesForm;
